import { useMemo } from 'react';
import { isEmpty } from 'lodash';
import { CustomSelect, withTooltip } from 'components';
import { OptionType } from 'components/CustomSelect/types';
import { useWaterfallContext } from 'pages/Waterfall/data/WaterfallContext/WaterfallContext';
import { CaptableListProps } from './CaptableList.props';

const CaptableList = ({ cell, ...restProps }: CaptableListProps) => {
  const { onCommit, onRevert, childrenCapTables } = restProps;
  const { capTableList } = useWaterfallContext();
  const getOptions = useMemo(() => {
    const tmpOptions: OptionType[] = [];

    if (capTableList && !isEmpty(capTableList)) {
      capTableList.forEach(capTable => {
        tmpOptions.push({
          label: capTable.name ?? '',
          value: capTable.id?.toString() ?? '',
        });
      });
      childrenCapTables.forEach(childCapTable => {
        tmpOptions.push({
          label: childCapTable.name ?? '',
          value: childCapTable.id?.toString() ?? '',
        });
      });
    }

    return tmpOptions;
  }, [capTableList, childrenCapTables]);

  return (
    <CustomSelect
      autoFocus
      id="captable-list"
      menuPlacement="bottom"
      onCommit={onCommit}
      onEmptyValue=""
      onRevert={onRevert}
      openMenuOnFocus
      options={getOptions}
      value={cell.value as string}
    />
  );
};

export default withTooltip(CaptableList);
